import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';

import { Alert as AlertModel } from '../models/Alert';

interface AlertProps {
  alert: AlertModel;
  onClose: () => void;
}

export const Alert: React.FunctionComponent<AlertProps> = ({
  alert,
  onClose,
}) => {
  const getBackgroundColor = (alertType: string) => {
    switch (alertType.toLowerCase()) {
      case 'actionable':
        return '#f57c00';
      case 'warning':
        return '#d32f2f';
      case 'info':
        return '#388e3c';
      default:
        return 'lightgray';
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: getBackgroundColor(alert.alertType),
        textAlign: 'center',
        padding: '8px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        color: 'white',
      }}
    >
      <Typography variant='body2' sx={{ flexGrow: 1 }}>
        {alert.description}
      </Typography>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          color: 'white',
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </Box>
  );
};
